import { ListProvider } from "./list-provider";
import { ContactType } from "../../../../business-objects/contact-type/contact-type.model";
import { ContactTypeStoreFacade } from "../../../../business-objects/contact-type/contact-type.store-facade";

export class ContactTypeListProvider extends ListProvider<ContactType> {

    getFacade(): ContactTypeStoreFacade {
        return this.appFacade.objects.contactType.store;
    }

    getPrimaryField(item: ContactType): string {
        return item && item.title;
    }

    getSecondaryField(item: ContactType): string {
        return item && item.title;
    }
}



// WEBPACK FOOTER //
// ./src/vas/controls/list-picker/form/list-providers/contact-type-list-provider.ts